import { IWidgetDefinition, IWidgetSettings, IWidget, IBaseSettings } from '../../common/core';
var template = require("./modal.html");
var styles = require("./modal.scss").toString();

export interface IModalSettings extends IBaseSettings {
    /**
     * Field names
     */
    fields?: string[];

    /**
     * Modal width
     */
    width?: string;

    /**
     * Title template
     */
    title?: string;

    /**
     * Body template
     */
    body?: string;
}

/**
* Settings for doc
*/
export interface IModalWidgetSettings extends IWidgetSettings<IModalSettings, null> {
    type: "modal"
}

export class ModalData {

    itemToShow: { item: any, origItem: any };

    /**
     * Title template override (from other widgets)
     */
    titleTemplate: string;

    /**
     * Body template override (from other widgets)
     */
    bodyTemplate: string;

    constructor(public widget: IWidget<ModalData, IModalSettings, null>) {

    }

    showItem(item, itemCopy?) {
        this.itemToShow = {
            item: itemCopy || JSON.parse(JSON.stringify(item)),
            origItem: item
        };
        this.attachShowEventListeners();
    }

    keydownShowHandler(e) {
        if (e.which == 27) {
            this.discardShow();
            e.preventDefault();
        }
    }

    globalShowKeydownHandler: any;
    attachShowEventListeners() {
        this.removeShowEventListeners();
        this.globalShowKeydownHandler = (event) => {
            this.widget.service['zone'].run(() => {
                this.keydownShowHandler(event);
            });
        };
        document.addEventListener('keydown', this.globalShowKeydownHandler);
    }

    removeShowEventListeners() {
        this.widget.service['zone'].runOutsideAngular(() => {
            if (this.globalShowKeydownHandler) {
                document.removeEventListener('keydown', this.globalShowKeydownHandler);
                this.globalShowKeydownHandler = null;
            }
        });
    }

    discardShow() {
        this.itemToShow = null;
        this.removeShowEventListeners();
    }

    destroy() {
        this.discardShow();
    }

    getFields() {
        if (this.widget.settings.fields) {
            return this.widget.settings.fields.join(',');
        }
    }
}

const ModalWidgetDefinition: IWidgetDefinition<ModalData, IModalSettings, null> = {
    init(widget) {
        widget.data = new ModalData(widget);
    },
    beforeSearch(widget, params) {

    },
    getQuery(widget) { },
    getFields(widget) {
        return widget.data.getFields();
    },
    getFacets(widget) { },
    onData(widget, data) { },
    destroy(w) {
        if (w.data.destroy) {
            w.data.destroy();
        }
    },
    template: template,
    styles: styles
};

export default ModalWidgetDefinition;
